// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* #region parent containers */
.customer-administrator-invoice-preview-parent-container{
    position: absolute;
    top: 0;
    left: 0;
    height: 65vh;
    text-align: center;
    overflow: auto;
    padding-bottom: 2vh;
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}
.customer-administrator-invoice-preview-parent-container.default{
    opacity: 0;
    transform: translateX(100%);
}
.customer-administrator-invoice-preview-parent-container.active{
    animation: customer-administrator-invoice-preview-parent-container-slide-in 0.4s ease-out forwards;
}
.customer-administrator-invoice-preview-parent-container.inactive{
    animation: customer-administrator-invoice-preview-parent-container-slide-out 0.4s ease-out forwards;
}
@keyframes customer-administrator-invoice-preview-parent-container-slide-in {
    from{
        opacity: 0;
        transform: translateX(100%);
    }
    to{
        opacity: 1;
        transform: translateX(0);
    }
}
@keyframes customer-administrator-invoice-preview-parent-container-slide-out {
    from{
        opacity: 1;
        transform: translateX(0);
    }
    to{
        opacity: 0;
        transform: translateX(100%);
    }
}
.customer-administrator-invoice-preview-parent-container::-webkit-scrollbar{
    width: 4px;
}
.customer-administrator-invoice-preview-parent-container::-webkit-scrollbar-thumb{
    border-radius: 5px;
    background-color: rgb(126, 126, 126);
}
.customer-administrator-invoice-preview-print-button{
    border: none;
    position: absolute;
    right: 4%;
    top: 4%;
    cursor: pointer;
    background-color: transparent;
    border-radius: 50%;
    transition: background-color 0.25s ease-in;
}
.customer-administrator-invoice-preview-print-button:hover{
    background-color: rgb(235, 235, 235);
}
.customer-administrator-invoice-preview-print-button img{
    height: 36px;
    padding: 5px 2px;
}
.customer-administrator-invoice-preview-container{
    margin-top: 20px;
    width: 75%;
    padding: 10px 20px;
    display: inline-block;
    text-align: left;
    cursor: default;
    padding-bottom: 50px;
    box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.2);
}
.customer-administrator-invoice-preview-header{
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid rgb(190, 190, 190);
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}
/* #endregion */
/* #region Header section */
.customer-administrator-invoice-preview-header .logo-section img{
    height: 100px;
}
.customer-administrator-invoice-preview-header .company-details-section h1{
    font-weight: 600;
    font-size: 32px;
    text-align: right;
    margin: 0px;
    margin-bottom: 10px;
    cursor: default;
    color: rgb(54, 54, 54);
}
.customer-administrator-invoice-preview-header .company-details-section h2{
    font-weight: 600;
    text-align: right;
    margin: 2px 0px;
    font-size: 14px;
    cursor: default;
}
.customer-administrator-invoice-preview-header .company-details-section p{
    margin: 2px 0px;
    text-align: right;
    font-size: 14px;
    cursor: default;
}
.customer-administrator-invoice-preview-header .company-contact-section{
    padding: 10px 0px;
}
.customer-administrator-invoice-preview-header .company-contact-section p{
    margin: 2px 0px;
    text-align: right;
    font-size: 14px;
    cursor: default;
}
.customer-administrator-invoice-preview-sub-header{
    display: flex;
    justify-content: space-between;
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}
.customer-administrator-invoice-preview-sub-header .invoice-primary-details-section{
    display: grid;
    grid-template-columns: 1fr 1fr;
    column-gap: 16px;
}
.customer-administrator-invoice-preview-sub-header .invoice-primary-details-section p{
    margin: 2px 0px;
    font-size: 14px;
    cursor: default;
}
.customer-administrator-invoice-preview-sub-header .invoice-primary-details-section p:nth-child(odd){
    text-align: right;
    font-weight: 600;
}
.customer-administrator-invoice-preview-sub-header .invoice-primary-details-section .total-price-p{
    font-weight: 600;
}
/* #endregion */
/* #region Devices subscriptions section */
#customer-administrator-invoice-preview-devices-subscriptions-header-strip{
    background-color: rgba(155, 30, 30, 0.952)!important;
}
.customer-administrator-invoice-preview-devices-subscriptions table{
    width: 100%;
    table-layout: fixed;
    border-collapse: collapse;
    border-bottom: 1px solid lightgray;
}
.customer-administrator-invoice-preview-devices-subscriptions table tr{
    background-color: white!important;
}
.customer-administrator-invoice-preview-devices-subscriptions table th{
    color: white;
    padding: 4px 10px;
    text-align: right;
    font-size: 14px;
}
.customer-administrator-invoice-preview-devices-subscriptions table th:first-child{
    width: 35%;
    text-align: left;
}
.customer-administrator-invoice-preview-devices-subscriptions table th:last-child{
    width: 20%;
}
.customer-administrator-invoice-preview-devices-subscriptions table th:last-child div{
    margin-right: 10px;
}
.customer-administrator-invoice-preview-devices-subscriptions table td{
    text-align: right;
}
.customer-administrator-invoice-preview-devices-subscriptions table td:first-child{
    text-align: left;
}
.customer-administrator-invoice-preview-devices-subscriptions table td:last-child div{
    margin-right: 15px;
}
/* #endregion */
/* #region Prices totals section */
.customer-administrator-invoice-preview-price-summary-parent-container{
    text-align: right;
    margin-top: 10px;
}
.customer-administrator-invoice-preview-price-summary-container{
    display: inline-block;
    text-align: right;
    padding-right: 20px;
}
.customer-administrator-invoice-preview-price-summary-container .sub-total-container,
.customer-administrator-invoice-preview-price-summary-container .tax-container,
.customer-administrator-invoice-preview-price-summary-container .total-container,
.customer-administrator-invoice-preview-price-summary-container .amount-due-container{
    display: grid;
    grid-template-columns: 1fr 200px;
}
.customer-administrator-invoice-preview-price-summary-container .sub-total-container p,
.customer-administrator-invoice-preview-price-summary-container .tax-container p,
.customer-administrator-invoice-preview-price-summary-container .total-container p,
.customer-administrator-invoice-preview-price-summary-container .amount-due-container p{
    margin: 2px 0px;
    font-size: 14px;
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}
.customer-administrator-invoice-preview-price-summary-container .total-container{
    padding: 2px 0px;
    margin: 2px 0px;
    border-top: 1px solid rgb(170, 170, 170);
    border-bottom: 1px solid rgb(170, 170, 170);
}
.customer-administrator-invoice-preview-price-summary-container .amount-due-container p{
    font-weight: 500;
}
/* #endregion */
/* #region Notes section */
.customer-administrator-invoice-preview-notes-container h2{
    font-weight: 700;
    font-size: 15px;
    margin: 4px 0px;
    color: rgb(68, 68, 68);
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}
.customer-administrator-invoice-preview-notes-container .notes-entry{
    font-size: 14px;
    color: rgb(65, 65, 65);
}
/* #endregion */`, "",{"version":3,"sources":["webpack://./src/styles/workspace_styles/CustomerAdministratorStyles/Invoices/Invoice/InvoicePreview.css"],"names":[],"mappings":"AAAA,8BAA8B;AAC9B;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,YAAY;IACZ,kBAAkB;IAClB,cAAc;IACd,mBAAmB;IACnB,4DAA4D;AAChE;AACA;IACI,UAAU;IACV,2BAA2B;AAC/B;AACA;IACI,kGAAkG;AACtG;AACA;IACI,mGAAmG;AACvG;AACA;IACI;QACI,UAAU;QACV,2BAA2B;IAC/B;IACA;QACI,UAAU;QACV,wBAAwB;IAC5B;AACJ;AACA;IACI;QACI,UAAU;QACV,wBAAwB;IAC5B;IACA;QACI,UAAU;QACV,2BAA2B;IAC/B;AACJ;AACA;IACI,UAAU;AACd;AACA;IACI,kBAAkB;IAClB,oCAAoC;AACxC;AACA;IACI,YAAY;IACZ,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,eAAe;IACf,6BAA6B;IAC7B,kBAAkB;IAClB,0CAA0C;AAC9C;AACA;IACI,oCAAoC;AACxC;AACA;IACI,YAAY;IACZ,gBAAgB;AACpB;AACA;IACI,gBAAgB;IAChB,UAAU;IACV,kBAAkB;IAClB,qBAAqB;IACrB,gBAAgB;IAChB,eAAe;IACf,oBAAoB;IACpB,8CAA8C;AAClD;AACA;IACI,aAAa;IACb,8BAA8B;IAC9B,2CAA2C;IAC3C,4DAA4D;AAChE;AACA,eAAe;AACf,2BAA2B;AAC3B;IACI,aAAa;AACjB;AACA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,WAAW;IACX,mBAAmB;IACnB,eAAe;IACf,sBAAsB;AAC1B;AACA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;IACf,eAAe;IACf,eAAe;AACnB;AACA;IACI,eAAe;IACf,iBAAiB;IACjB,eAAe;IACf,eAAe;AACnB;AACA;IACI,iBAAiB;AACrB;AACA;IACI,eAAe;IACf,iBAAiB;IACjB,eAAe;IACf,eAAe;AACnB;AACA;IACI,aAAa;IACb,8BAA8B;IAC9B,4DAA4D;AAChE;AACA;IACI,aAAa;IACb,8BAA8B;IAC9B,gBAAgB;AACpB;AACA;IACI,eAAe;IACf,eAAe;IACf,eAAe;AACnB;AACA;IACI,iBAAiB;IACjB,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA,eAAe;AACf,0CAA0C;AAC1C;IACI,oDAAoD;AACxD;AACA;IACI,WAAW;IACX,mBAAmB;IACnB,yBAAyB;IACzB,kCAAkC;AACtC;AACA;IACI,iCAAiC;AACrC;AACA;IACI,YAAY;IACZ,iBAAiB;IACjB,iBAAiB;IACjB,eAAe;AACnB;AACA;IACI,UAAU;IACV,gBAAgB;AACpB;AACA;IACI,UAAU;AACd;AACA;IACI,kBAAkB;AACtB;AACA;IACI,iBAAiB;AACrB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,kBAAkB;AACtB;AACA,eAAe;AACf,kCAAkC;AAClC;IACI,iBAAiB;IACjB,gBAAgB;AACpB;AACA;IACI,qBAAqB;IACrB,iBAAiB;IACjB,mBAAmB;AACvB;AACA;;;;IAII,aAAa;IACb,gCAAgC;AACpC;AACA;;;;IAII,eAAe;IACf,eAAe;IACf,4DAA4D;AAChE;AACA;IACI,gBAAgB;IAChB,eAAe;IACf,wCAAwC;IACxC,2CAA2C;AAC/C;AACA;IACI,gBAAgB;AACpB;AACA,eAAe;AACf,0BAA0B;AAC1B;IACI,gBAAgB;IAChB,eAAe;IACf,eAAe;IACf,sBAAsB;IACtB,4DAA4D;AAChE;AACA;IACI,eAAe;IACf,sBAAsB;AAC1B;AACA,eAAe","sourcesContent":["/* #region parent containers */\n.customer-administrator-invoice-preview-parent-container{\n    position: absolute;\n    top: 0;\n    left: 0;\n    height: 65vh;\n    text-align: center;\n    overflow: auto;\n    padding-bottom: 2vh;\n    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\n}\n.customer-administrator-invoice-preview-parent-container.default{\n    opacity: 0;\n    transform: translateX(100%);\n}\n.customer-administrator-invoice-preview-parent-container.active{\n    animation: customer-administrator-invoice-preview-parent-container-slide-in 0.4s ease-out forwards;\n}\n.customer-administrator-invoice-preview-parent-container.inactive{\n    animation: customer-administrator-invoice-preview-parent-container-slide-out 0.4s ease-out forwards;\n}\n@keyframes customer-administrator-invoice-preview-parent-container-slide-in {\n    from{\n        opacity: 0;\n        transform: translateX(100%);\n    }\n    to{\n        opacity: 1;\n        transform: translateX(0);\n    }\n}\n@keyframes customer-administrator-invoice-preview-parent-container-slide-out {\n    from{\n        opacity: 1;\n        transform: translateX(0);\n    }\n    to{\n        opacity: 0;\n        transform: translateX(100%);\n    }\n}\n.customer-administrator-invoice-preview-parent-container::-webkit-scrollbar{\n    width: 4px;\n}\n.customer-administrator-invoice-preview-parent-container::-webkit-scrollbar-thumb{\n    border-radius: 5px;\n    background-color: rgb(126, 126, 126);\n}\n.customer-administrator-invoice-preview-print-button{\n    border: none;\n    position: absolute;\n    right: 4%;\n    top: 4%;\n    cursor: pointer;\n    background-color: transparent;\n    border-radius: 50%;\n    transition: background-color 0.25s ease-in;\n}\n.customer-administrator-invoice-preview-print-button:hover{\n    background-color: rgb(235, 235, 235);\n}\n.customer-administrator-invoice-preview-print-button img{\n    height: 36px;\n    padding: 5px 2px;\n}\n.customer-administrator-invoice-preview-container{\n    margin-top: 20px;\n    width: 75%;\n    padding: 10px 20px;\n    display: inline-block;\n    text-align: left;\n    cursor: default;\n    padding-bottom: 50px;\n    box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.2);\n}\n.customer-administrator-invoice-preview-header{\n    display: flex;\n    justify-content: space-between;\n    border-bottom: 1px solid rgb(190, 190, 190);\n    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\n}\n/* #endregion */\n/* #region Header section */\n.customer-administrator-invoice-preview-header .logo-section img{\n    height: 100px;\n}\n.customer-administrator-invoice-preview-header .company-details-section h1{\n    font-weight: 600;\n    font-size: 32px;\n    text-align: right;\n    margin: 0px;\n    margin-bottom: 10px;\n    cursor: default;\n    color: rgb(54, 54, 54);\n}\n.customer-administrator-invoice-preview-header .company-details-section h2{\n    font-weight: 600;\n    text-align: right;\n    margin: 2px 0px;\n    font-size: 14px;\n    cursor: default;\n}\n.customer-administrator-invoice-preview-header .company-details-section p{\n    margin: 2px 0px;\n    text-align: right;\n    font-size: 14px;\n    cursor: default;\n}\n.customer-administrator-invoice-preview-header .company-contact-section{\n    padding: 10px 0px;\n}\n.customer-administrator-invoice-preview-header .company-contact-section p{\n    margin: 2px 0px;\n    text-align: right;\n    font-size: 14px;\n    cursor: default;\n}\n.customer-administrator-invoice-preview-sub-header{\n    display: flex;\n    justify-content: space-between;\n    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\n}\n.customer-administrator-invoice-preview-sub-header .invoice-primary-details-section{\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    column-gap: 16px;\n}\n.customer-administrator-invoice-preview-sub-header .invoice-primary-details-section p{\n    margin: 2px 0px;\n    font-size: 14px;\n    cursor: default;\n}\n.customer-administrator-invoice-preview-sub-header .invoice-primary-details-section p:nth-child(odd){\n    text-align: right;\n    font-weight: 600;\n}\n.customer-administrator-invoice-preview-sub-header .invoice-primary-details-section .total-price-p{\n    font-weight: 600;\n}\n/* #endregion */\n/* #region Devices subscriptions section */\n#customer-administrator-invoice-preview-devices-subscriptions-header-strip{\n    background-color: rgba(155, 30, 30, 0.952)!important;\n}\n.customer-administrator-invoice-preview-devices-subscriptions table{\n    width: 100%;\n    table-layout: fixed;\n    border-collapse: collapse;\n    border-bottom: 1px solid lightgray;\n}\n.customer-administrator-invoice-preview-devices-subscriptions table tr{\n    background-color: white!important;\n}\n.customer-administrator-invoice-preview-devices-subscriptions table th{\n    color: white;\n    padding: 4px 10px;\n    text-align: right;\n    font-size: 14px;\n}\n.customer-administrator-invoice-preview-devices-subscriptions table th:first-child{\n    width: 35%;\n    text-align: left;\n}\n.customer-administrator-invoice-preview-devices-subscriptions table th:last-child{\n    width: 20%;\n}\n.customer-administrator-invoice-preview-devices-subscriptions table th:last-child div{\n    margin-right: 10px;\n}\n.customer-administrator-invoice-preview-devices-subscriptions table td{\n    text-align: right;\n}\n.customer-administrator-invoice-preview-devices-subscriptions table td:first-child{\n    text-align: left;\n}\n.customer-administrator-invoice-preview-devices-subscriptions table td:last-child div{\n    margin-right: 15px;\n}\n/* #endregion */\n/* #region Prices totals section */\n.customer-administrator-invoice-preview-price-summary-parent-container{\n    text-align: right;\n    margin-top: 10px;\n}\n.customer-administrator-invoice-preview-price-summary-container{\n    display: inline-block;\n    text-align: right;\n    padding-right: 20px;\n}\n.customer-administrator-invoice-preview-price-summary-container .sub-total-container,\n.customer-administrator-invoice-preview-price-summary-container .tax-container,\n.customer-administrator-invoice-preview-price-summary-container .total-container,\n.customer-administrator-invoice-preview-price-summary-container .amount-due-container{\n    display: grid;\n    grid-template-columns: 1fr 200px;\n}\n.customer-administrator-invoice-preview-price-summary-container .sub-total-container p,\n.customer-administrator-invoice-preview-price-summary-container .tax-container p,\n.customer-administrator-invoice-preview-price-summary-container .total-container p,\n.customer-administrator-invoice-preview-price-summary-container .amount-due-container p{\n    margin: 2px 0px;\n    font-size: 14px;\n    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\n}\n.customer-administrator-invoice-preview-price-summary-container .total-container{\n    padding: 2px 0px;\n    margin: 2px 0px;\n    border-top: 1px solid rgb(170, 170, 170);\n    border-bottom: 1px solid rgb(170, 170, 170);\n}\n.customer-administrator-invoice-preview-price-summary-container .amount-due-container p{\n    font-weight: 500;\n}\n/* #endregion */\n/* #region Notes section */\n.customer-administrator-invoice-preview-notes-container h2{\n    font-weight: 700;\n    font-size: 15px;\n    margin: 4px 0px;\n    color: rgb(68, 68, 68);\n    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\n}\n.customer-administrator-invoice-preview-notes-container .notes-entry{\n    font-size: 14px;\n    color: rgb(65, 65, 65);\n}\n/* #endregion */"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
